import { http, HttpResponse, delay } from 'msw';

import { mockRoles } from '@/mocks/data/roleData';

export const roleHandlers = [
  http.get('*/v1/roles', async () => {
    await delay();
    return HttpResponse.json(mockRoles, { status: 200 });
  }),
];
